import { Bytes2HexString, toGbkBytes } from './vue_gbk'
// web serial相关配置
let writer = {}
let port = ''; let serialState = false; const state = ''
let reader = {}

export function serialPrint(labelName) {
  // 打印二维码数据
  const initQrCode = Bytes2HexString(toGbkBytes(labelName)).toLocaleUpperCase()
  return initQrCode
}

// 请求授权
export async function handleRequestPort(baudRate = 9600) {
  // 请求授权
  if (port == '') {
    port = await navigator.serial.requestPort()
  }
  console.log(port, 'port')
  await port.open({ baudRate: baudRate })
  writer = await port.writable.getWriter()
  reader = await port.readable.getReader()
}

export function getWriter() {
  return writer
}

export function getPort() {
  return port
}

export function getReader() {
  return reader
}

// 设置串口状态
export function setSerialState(state) {
  serialState = state
}

// 获取串口状态
export function getSerialState() {
  return serialState
}
// 清空串口缓存
export function clearPort() {
  console.log('清空port')
  port = ''
}
